import {
  axiosInstance,
  GET_ALL_COURSE_BLOGS,
  GET_COURSE_BLOG_BY_ID,
} from "../apiurls/apiurls";

export const getAllCourseBlogs = async (courseKey) => {
  try {
    const response = await axiosInstance.get(GET_ALL_COURSE_BLOGS, {
      params: { course: courseKey },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching all course blogs:", error);
    throw error;
  }
};

export const getCourseBlogById = async (id) => {
  try {
    const response = await axiosInstance.get(GET_COURSE_BLOG_BY_ID, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching course blog by ID:", error);
    throw error;
  }
};
